import ApiService from '../api.services';

const BankService = {
    list: async function () {
        try {
            const response = await ApiService.get('/api/bank');
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    get: async function (id) {
        try {
            const response = await ApiService.get(`/api/bank/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    add: async function (form) {
        const data = {
            bank: form
        }
        try {
            const response = await ApiService.post('/api/bank', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    update: async function (id, form) {
        const data = {
            bank: form
        }
        try {
            const response = await ApiService.put(`/api/bank/${id}`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    delete: async function (id) {
        try {
            const response = await ApiService.delete(`/api/bank/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
};

export default BankService;

export { BankService };

